import PropTypes from 'prop-types';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export const sliderThumbPropTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    invalid: PropTypes.bool,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    step: PropTypes.number,
    value: PropTypes.number.isRequired,
};
export const sliderPropTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    displayFormat: PropTypes.func,
    hint: PropTypes.string,
    id: PropTypes.string.isRequired,
    invalid: PropTypes.bool,
    label: PropTypes.string,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    step: PropTypes.number,
    validationMessage: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number.isRequired),
    ]).isRequired,
    valueFormat: PropTypes.func,
    children: PropTypes.func,
    ...spacingPropTypes,
};
//# sourceMappingURL=Slider.types.js.map